import { Component, OnInit } from '@angular/core';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { colors } from 'src/utils/colors';

import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {DatePipe, Location} from '@angular/common';
import { Router,ActivatedRoute  } from "@angular/router";
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { browserRefresh } from 'src/app/app.component';
import { Subject } from 'rxjs';

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';


import {

  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
  CalendarDayViewBeforeRenderEvent,

} from 'angular-calendar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';



interface Appointment {
  PID:string;
 fullName: string;
 timeIn: string;
 appointmentID:string;
 phoneNumber:string;
 branch:string;
 salesRep:string;
 status:string;
  
}


@Component({
  selector: 'app-sales-rep-home',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sales-rep-home.component.html',
  styleUrls: ['./sales-rep-home.component.css']
})



export class SalesRepHomeComponent implements OnInit {

 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
 _url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 
 fabButtons = [
  {
    icon: 'date_range',
    click:'getFabButtonOption("btn.click")',
    title: "Sales Rep Availability"
  },
  {
    icon: 'contacts',
    title:"Client Search"
  }/**,
  {
    icon: 'room'
  },
  {
    icon: 'lightbulb_outline'
  },
  {
    icon: 'lock'
  }**/
];
buttons = [];
fabTogglerState = 'inactive';

validationMessages = {
  'salesRep': {
    'required': 'required',
    
  },
  'dayoffDate': {
    'required': 'required',
  },
  'blockoffDaytimeIn': {
    'required': 'required',
  },
  'blockoffDaytimeOut': {
    'required': 'required',
  },
  'requestType': {
    'required': 'required',
  },

};


formErrors = {
  'salesRep': '',
  'dayoffDate': '',
  'blockoffDaytimeIn':'',
  'blockoffDaytimeOut':'',
  'requestType':'',
 
};
clientSearchForm: FormGroup;
 tagForm : FormGroup;
 searchForm: FormGroup;
 tablerequestTypearray;
 clientSearchList:any=[];
 OffMessage;
 searchText;
 branchselected;
 
 allappointment;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  salesReplist;
  color;
  success;
error;
branch;
myappointment=[];
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ appointment: Appointment }>[]>;
  viewDate: Date = new Date();
//  events: Array<CalendarEvent<{time:any}>>;
 //events:CalendarEvent[];
  currentUser:User;
loggedInUserBranch;
loggedInUserFullname;
loggedInUsername;
loggedInUserId;
mytableappointment;
mytabletodayappointment;
inProgressModalList;
salesrepfreetime;
refresh: Subject<any> = new Subject();

constructor(private _authenticationService: AuthenticationService,
  private modalService: NgbModal,
  private router: Router, 
  private fb: FormBuilder,
  private actroute: ActivatedRoute,
  private _location: Location,
  private _appointment: AppointmentService,
  private _http: HttpClient,
  public datepipe: DatePipe) {

    
    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
      this.loggedInUsername=this.currentUser.userName;
    this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
    this.loggedInUserBranch=this.currentUser.branch;
    this.loggedInUserId=this.currentUser.userName;
this.branch=this.loggedInUserBranch;
    }
   }

   activeDayIsOpen: boolean = false;

  ngOnInit(): void {
    this.getSalesRepAppointment();
    this.getSalesRepAppointmentForToday();
    this.getSalesRepList(this.branch);
   this.fetchEvents();
  
    
   // this.getMyAppointments(this.loggedInUserFullname);

  /** this._appointment.getMyAppointment(this.loggedInUserFullname).subscribe(
    (res) => {
      this.myappointment= res;
      console.log(this.myappointment);

/**  for(let i=0; i<res[0].length; i++) {
      this.items.push(
      {
        title: res[0][i].fullName,
        start: new Date(res[0][i].timeIn),
        color: colors.yellow,
        meta: {
          time: res[0].timeIn
        }
    });
    this.events = this.items;
    
   
  }**/
  


      
 /**   },
    (err) => {
      this.error = err;
    }
  );**/
  //eventClicked({month});
 // this.refresh.next();
  //this.view = CalendarView.Month;
 
  
  
    
  this.tagForm = this.fb.group({
    modalMsg: new FormControl(''),
    pid: new FormControl(''),
    fullName: new FormControl(''),
    timeIn: new FormControl(''),
    tag: new FormControl('', [Validators.required]),
    branch: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });


  this.clientSearchForm = this.fb.group({
    modalMsg: new FormControl(''),
    phone: new FormControl('', [Validators.required]),
    branch: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });
  
  this.searchForm = this.fb.group({
    searchPhoneText: new FormControl(''),
  });
  


  var allappointments = document.getElementById("allappointments");
  allappointments.style.display = "none";
  var allappointmentsview=document.getElementById ("allappointmentsview");
  allappointmentsview.style.backgroundColor='#132a42';
  allappointmentsview.style.color="#FFFFFF";

  var todaysappointments = document.getElementById("todaysappointments");
  todaysappointments.style.display = "block";
  var todaysappointmentsview = document.getElementById ("todaysappointmentsview");
  todaysappointmentsview.style.backgroundColor='#FFFFFF';
  todaysappointmentsview.style.color="#132a42";


  document.getElementById ("todaysappointmentsview").addEventListener ("click", TodaysAppointmentsFunction, false);
  document.getElementById ("allappointmentsview").addEventListener ("click", AllAppointmentsFunction, false);
  
  }//End of NgOnInit

/**  eventClicked({ event }: { event: CalendarEvent }): void {
    console.log('Event clicked', event);
  }**/



  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

/********************************************************* */
clientSearch(phoneNumber){
  console.log(phoneNumber)
       this._appointment.searchClient(phoneNumber).subscribe(
         (res) => {
           this.clientSearchList= res;
         //  console.log(this.clientSearchList);
  
      });
    }
  
    openFABModal(icon){
      console.log(icon);
      if(icon=="date_range"){
        this.salesRepFreeTimeModal();
      }
      else if(icon=="contacts"){
        this.searchClientModal();
      }
    }
   /********************************************************* */
  
  
  salesRepFreeTimeModal(){
    this.getSalesRepFreeTime();
    document.getElementById('openSalesRepAvailabilityModalButton').click();
    
  }
   /********************************************************* */
  
   searchClientModal(){
   document.getElementById('openClientSearchModalButton').click();
  
   }
  
   openClientDetails(client){
  
    this.router.navigate(['../client-details', { extra:client.pid, extra1: client.fullName,extra2:client.phoneNumber,extra3:client.email}], { relativeTo: this.actroute });
   }
    /********************************************************* */
  
    getSalesRepFreeTime(){
      console.log(this.branch);
     var qdate=new Date();
     var queryDate=this.datepipe.transform(qdate,'yyyy-MM-dd H:mm:s');
     console.log(queryDate);
       this._appointment.getSalesRepFreeTime(this.branch,queryDate).subscribe(
         (res) => {
           this.salesrepfreetime= res;
         //  console.log(this.salesrepfreetime);
  
            this.tablerequestTypearray=Object.entries(this.salesrepfreetime).map(([key,value])=>{
        const y={[" "]:key}
        return Object.assign({},y,value)
      })
  
    
      //console.log(this.tablerequestTypearray);
    
      const headers=Object.keys(this.tablerequestTypearray[0])
      //console.log(headers)
      var stringversion=JSON.stringify(this.tablerequestTypearray,null,4);
           
         },
         (err) => {
           this.error = err;
         }
       );
     
     }
   /********************************************************* */
  
  createAptFromFreeTime(salesRep,datetime){
   // console.log(salesRep);
    const now = Date.now();
    const myFormattedDate = this.datepipe.transform(now, 'longDate');
   // console.log(myFormattedDate);
    var ded=new Date(datetime);
    //var ddd=this.datepipe.transform(ded,'H:mm:ss');
     //var time=new Date(myFormattedDate.setTime(21136)); 
      var  finaltime=this.datepipe.transform(myFormattedDate+" "+datetime, 'yyyy-MM-dd H:mm:ss');
    //var finaldate=Date()
    //console.log(finaltime);
    
    this.router.navigate(['../create-appointment',{extra:salesRep,extra1:finaltime,extra2:this.branch}],{relativeTo:this.actroute});
    this.modalService.dismissAll();
  }
  
  /********************************************************* */

getSalesRepAppointment(){

  this._appointment.getSalesRepAppointmentByIDMainTable(this.loggedInUsername,this.loggedInUserBranch).subscribe(
    (res) => {
      this.mytableappointment= res[0];
    //  console.log(this.mytableappointment);
      if(this.mytableappointment[0]['ERROR']=='no appointment'){
        this.mytableappointment='no appointment'
      }
      
    },
    (err) => {
      this.error = err;
    }
  );

}
 /********************************************************* */

 getSalesRepAppointmentForToday(){
//console.log(this.loggedInUsername);
//console.log(this.loggedInUserBranch);
  this._appointment.getSalesRepAppointmentForTodayByIDMainTable(this.loggedInUsername,this.loggedInUserBranch).subscribe(
    (res) => {
      console.log(res[0]);
      this.mytabletodayappointment= res[0];
      console.log(this.mytabletodayappointment);
     
    },
    (err) => {
      this.error = err;
    }
  );

}
/********************************************************* */

openInProgressModal(modal,apt){
  //console.log(apt);
   this.inProgressModalList=apt;
       var finalmessage= "Please enter: "
     
   
     this.modalService.open(modal, {
       centered: true,
       backdrop: 'static'
     });
   
    
     
   }


   /***************************************************** */


/********************************************************* */

editAppointment(list){
  //console.log(list);
   if(list.fullName=='Lunch'){
     this.router.navigate(['../lunch-assignment',{extra:list.pid,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
   }else{
  
  
    this.router.navigate(['../appointment-edit',{extra:list.pid,extra1:list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
   }
 }
openTagModal(modal,apt){
 //console.log(apt);
  this.getSalesRepList(this.loggedInUserBranch);
      var finalmessage= "Please enter: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });
  
    this.tagForm.patchValue({
      modalMsg: finalmessage,
      pid: apt.pid,
      fullName:apt.fullName,
      timeIn:apt.timeIn,
      tag: apt.tag,
      branch: this.loggedInUserBranch
    
      
     });
    
  }

  /********************************************************* */
   getSalesRepList(branch){
    //  console.log(branch);
      if (branch != "None" || branch!="") {
        this._appointment.getSalesRepByBranch(branch).subscribe(
          (res) => {
            this.salesReplist = res;
         console.log(this.salesReplist);
            
         
          }
          ,
          (err) => {
            this.error = err;
          }
        );
      }
   
      }
/********************************************************* */

openAppointment(list){
  //console.log(list.pid);
  
  
  this.router.navigate(['../appointment-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn }], { relativeTo: this.actroute });
  
}


/********************************************************* */

deleteAppointment(list){
  this._appointment.deleteAppointmentbypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessDeleteModalButton").click();
    
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}
/********************************************************* */
inprogressAppointment(){
var count=((document.getElementById("personcount") as HTMLInputElement).value);
//console.log(count);
this.inProgressModalList['status']="In Progress";
this.inProgressModalList['personCount']=count;
this.modalService.dismissAll();
this._appointment.setAppointmentStatusbypid(this.inProgressModalList)
 .subscribe(//subscribe to Observable
   response => {console.log('Success!', response);
   this.success=response['SUCCESS'];
       
   document.getElementById("openSuccessStatusUpdateModalButton").click();
   
 },
   error => {console.error('Error!', error);
   this.error=error.error.text ;
 }       
 );
}

/********************************************************* */
cancelAppointment(list){
// console.log(list);
list['status']="Cancelled";
 this._appointment.setAppointmentStatusbypid(list)
 .subscribe(//subscribe to Observable
   response => {console.log('Success!', response);
   this.success=response['SUCCESS'];
       
   document.getElementById("openSuccessStatusUpdateModalButton").click();
   
 },
   error => {console.error('Error!', error);
   this.error=error.error.text ;
 }       
 );
}
/********************************************************* */
completeAppointment(list){
 // console.log(list);
 list['status']="Completed"
  this._appointment.setAppointmentStatusbypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessStatusUpdateModalButton").click();
    
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}
/********************************************************* */

clearbarScanAppointment(list){
  // console.log(list);
   this._appointment.clearbarScanbypid(list)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccesssModalButton").click();
     this. getSalesRepAppointment;
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
 }
/********************************************************* */

checkbarScan(date){
if(date!=null && date!=""){
  var actualdatetime=new Date(date);
  var currentdatetime=new Date();
  var  daterange=new Date(actualdatetime.setMinutes(actualdatetime.getMinutes() + 60));
//console.log(currentdatetime);
if(currentdatetime<=daterange){
  return true;
} else 
{
  return false;
} }else{
  return false;

}
}  
/****************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  
    //this.events$ = this._http.get(`${this._url}/active_appointment_for_salesrep_get.php?salesRep=${this.loggedInUserFullname}`)
    this.events$ = this._http.get(`${this._url}/active_appointment_for_salesrep_get.php?salesRep=${this.loggedInUsername}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
     // this.allappointment=results;
    console.log(results);
      return results.map((appointment: Appointment) => {
       /**if(appointment.status=='In Progress'){
          this.color=colors.blue;
        }else if(appointment.status=='Pending'){
          this.color=colors.yellow;
        }else if(appointment.status=='Completed'){
          this.color=colors.green;
        }else if(appointment.status=='Cancelled'){
          this.color=colors.red;
        }else {
          this.color=colors.purple;
        }*/
        this.colorForRep(appointment.salesRep);
    //    console.log(appointment.status);
        return {
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' '),
          start: new Date(
            appointment.timeIn
          ),
          color: this.color,
          
          meta: {
            appointment,
          },
        };
      });
    })
  );


}



colorForRep(salesRep){
//console.log(salesRep);
  if(this.salesReplist.some(array=> array.userID===salesRep)){
    const i= this.salesReplist.findIndex(array=> array.userID===salesRep);
   // console.log(salesRep);
    
   // console.log(this.salesReplist[i])
    if(this.salesReplist[i].color!=null && this.salesReplist[i].color!=""){
      var colour=new String(this.salesReplist[i].color);
      //console.log(this.salesReplist[i].color);
    this.color={primary:this.salesReplist[i].color,secondary:this.salesReplist[i].color};
    } else if(salesRep==''){
      this.color=colors.red;
    } else {
      this.color=colors.black;
    }
    }
  else if(salesRep==''){
    this.color=colors.red;
  } else {
    this.color=colors.black;
  }

}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ appointment: Appointment }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}

/*************************************************************************************************/

eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  //console.log(event.meta.appointment);
  if(event.meta.appointment.fullName=='Lunch'){
    
   // this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.appointmentID,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRep,extra3:event.meta.appointment.branch}],{relativeTo:this.actroute});
  }else{
 
 
  this.router.navigate(['../appointment-details', { extra:event.meta.appointment.appointmentID, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch }], { relativeTo: this.actroute });
  }
}

 /*************************************************************************************************/ 

 /** for (let i=0; i<this.myappointment[0].length; i++) {
    console.log(this.myappointment[0][i].fullName);
    events: CalendarEvent[]=[{
        title: this.myappointment[0][i].fullName,
        start: new Date(),
        color: colors.yellow,
    }],
    alert(JSON.stringify(this.events))
}

  }


  /**
 events: CalendarEvent[] = [
   
  {
    title: "",
    color:colors,
    start:new Date(),
  },
 /**{
      title: "Jibran",
      color: colors.yellow,
      start: new Date(),
    },
    {
      title: 'Or click me',
      color: colors.blue,
      start: new Date(),
    },*/
  //]; 

/**   eventClicked({ event }: { event: CalendarEvent }): void {
    console.log('Event clicked', event);
  }

*/


  /**getMyAppointments(salesRep){
    this._appointment.getMyAppointment(salesRep).subscribe(
      (res) => {
        this.myappointment= res;
        console.log(this.myappointment);
this.events=[];
        for (let i=0; i<res.length; i++) {
          console.log(res[0][i].fullName);
          this.events=[{
              title: res[0][i].fullName,
              start: res[0][i].timeIn,
              color: colors.yellow
          }];
      }
     /**   for (var _i = 0; _i < this.myappointment.length; _i++) {
        //this.myappointment.forEach(function(appointment){
          console.log(this.myappointment[_i]);
          this.events = [
            {
              title: 'test',// this.myappointment[_i].fullName,
              color: colors.yellow,
              start: new Date(),//new Date(this.myappointment[_i].timeIn),
            },
          ];
        
        
        }*/



        
  /**    },
      (err) => {
        this.error = err;
      }
    );
  
  }**/
  
 /*************************************************************************************************/


  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }
  
  isReceptionist() {
    return this.currentUser && this.currentUser.role === UserRole.Receptionist;
  }
  
  isSalesRep() {
    return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
  }
  
  isPowerUser() {
    return this.currentUser && this.currentUser.role === UserRole.PowerUser;
  }
  
  isSalesSupport() {
    return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
  }
  
  /*************************************************************************************************/
logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
            console.log(key);
         

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}
 
}


function AllAppointmentsFunction() {
  var allappointments = document.getElementById("allappointments");
  allappointments.style.display = "block";
  var allappointmentsview = document.getElementById ("allappointmentsview");
  allappointmentsview.style.backgroundColor='#FFFFFF';
  allappointmentsview.style.color="#132a42";

  var todaysappointments = document.getElementById("todaysappointments");
  todaysappointments.style.display = "none";
  var todaysappointmentsview = document.getElementById ("todaysappointmentsview");
  todaysappointmentsview.style.backgroundColor='#132a42';
  todaysappointmentsview.style.color="#FFFFFF";
}




function TodaysAppointmentsFunction() {
  var todaysappointments = document.getElementById("todaysappointments");
  todaysappointments.style.display = "block";


  var todaysappointmentsview = document.getElementById ("todaysappointmentsview");
  todaysappointmentsview.style.backgroundColor='#FFFFFF';
  todaysappointmentsview.style.color="#132a42";


  var allappointments = document.getElementById("allappointments");
  allappointments.style.display = "none";
  
  var allappointmentsview = document.getElementById ("allappointmentsview");
  allappointmentsview.style.backgroundColor='#132a42';
  allappointmentsview.style.color="#FFFFFF";
}

